<body>
    <!--  Body Wrapper -->
    <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
      data-sidebar-position="fixed" data-header-position="fixed">

      <div class="d-flex justify-content-end">
        <button (click)="close()" type="button" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="body-wrapper">
        <div class="container-fluid ">
          <div class="row">
            <div class="container my-4">

              <div class="align-items-center justify-content-between">

                <div class="card">

                  <div class="card-body">
                    <h5 id="upper" class="" style="color: black;">Informations produit</h5>
                    <div class="container mt-4">

                      <form>
                        <div class="row g-3">
                          <div class="col-12 col-md-4">
                            <label for="nom" class="form-label">Nom produit</label>
                            <input [(ngModel)]="item.nom" name="nom" type="text" class="form-control" id="nom" placeholder="Nom du produit">
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="categorie" class="form-label">Categorie</label>
                            <select [(ngModel)]="item.categorie_produit_id" name="categorie" class="form-select" id="categorie">
                              <option selected>Choisir la catégorie</option>
                              <option *ngFor="let item of categorieProduitItems" [value]="item.id">{{ item.nom }}</option>
                            </select>
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="uniteMesure" class="form-label">Unité de mesure</label>
                            <select [(ngModel)]="item.unite_mesure_id" name="uniteMesure" class="form-select" id="uniteMesure">
                              <option selected>Choisir l'unité de mesure</option>
                              <option *ngFor="let item of uniteItems" [value]="item.id">{{ item.nom }}</option>
                            </select>
                          </div>

                          <div class="col-12 col-md-4">
                            <label for="etat" class="form-label">Etat</label>
                            <select [(ngModel)]="item.etat_produit_id" name="etat" class="form-select" id="etat">
                              <option selected>Choisir l'état</option>
                              <option *ngFor="let item of etatProduitItems" [value]="item.id">{{ item.nom }}</option>

                            </select>
                          </div>
                          <div class="col-12 col-md-4">
                            <label for="variete" class="form-label">Variété</label>
                            <select [(ngModel)]="item.variete_produit_id" name="variete" class="form-select" id="variete">
                              <option selected>Choisir la varité</option>
                              <option *ngFor="let item of varieteItems" [value]="item.id">{{ item.nom }}</option>
                            </select>
                          </div>
                          <div class="form-group  col-md-4">
                            <label for="name">Photo</label>

                            <input (change)="onFileSelected($event)" name="photo" type="file" class="form-control"
                              id="name">

                          </div>
                          <div  *ngIf="item" class="mt-3 d-flex justify-content-center">
                            <img [src]="photoPreview" alt="Aperçu de la photo" style="width: 50%; height: 300px;">
                        </div>
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                          <a  title="Cliquez ici pour annuler " href="javascript: void(0);" (click)="close()"
                          class="btn btn-secondary me-3"
                          style="color: white; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                          Annuler &nbsp;
                        </a>

                          <a (click)="updateProduit()" title="Cliquez ici pour enregistrer " href="javascript: void(0);"
                             class="btn"
                            style="color: white; background-color: #578D63; border: none; font-weight: 800; font-size: 16px; height: 38px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                            Enregistrer &nbsp;<i class="pi pi-save " style="font-size: 1rem"></i>

                          </a>
                        </div>

                      </form>

                    </div>


                  </div>
                </div>
              </div>



            </div>

          </div>
        </div>
      </div>
    </div>

  </body>


